import PropTypes from 'prop-types';
import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import IncentiveLink from './IncentiveLink';
import { CONDITIONAL_SPECIAL_DESCRIPTION } from '../constants/constants';

class IncentiveDetailCategorized extends React.Component {
	constructor(props) {
		super(props);
		this.showModalData = this.showModalData.bind(this);
	}

	showModalData(incentive, isModalVisible) {
		this.props.setModalStateData(incentive, isModalVisible);
	}

	render() {
		const {
			incentives,
			labels,
			heading,
			headingInfo,
			footnoteConditional,
			isMobile
		} = this.props;
		let incentivesList = null;

		if (incentives.length) {
			const body = incentives.map(incentive => {
				const { key } = incentive;
				return (
					<IncentiveLink
						key={key}
						incentive={incentive}
						showModalData={this.showModalData}
						showFootnote={
							footnoteConditional && incentive.conditional
						}
					/>
				);
			});

			// Add heading and tooltip if needed
			let listHeading;
			let headingTooltip;
			if (heading) {
				if (headingInfo) {
					const popoverPlacement = isMobile ? 'top' : 'left';
					const popoverHoverFocus = (
						<Popover id="incentive-detail-popover">
							{labels.get(CONDITIONAL_SPECIAL_DESCRIPTION)}
						</Popover>
					);

					headingTooltip = (
						<OverlayTrigger
							trigger={['hover', 'focus']}
							placement={popoverPlacement}
							overlay={popoverHoverFocus}
						>
							<span>
								<i className="ddc-icon ddc-icon-info text-muted d-inline-block pl-1" />
							</span>
						</OverlayTrigger>
					);
				}

				listHeading = (
					<h5 className="pt-3">
						{heading}
						{headingTooltip}
					</h5>
				);
			}
			incentivesList = (
				<div>
					{listHeading}
					<ul className="list-unstyled line-height-condensed mb-0">
						{body}
					</ul>
				</div>
			);
		}
		return incentivesList;
	}
}

IncentiveDetailCategorized.propTypes = {
	incentives: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			title: PropTypes.string,
			label: PropTypes.string,
			offerDetails: PropTypes.string,
			shortTitle: PropTypes.string,
			disclaimer: PropTypes.string,
			effectiveDate: PropTypes.string,
			expirationDate: PropTypes.string,
			conditional: PropTypes.bool,
			manufacturerOffer: PropTypes.bool
		}).isRequired
	).isRequired,
	labels: PropTypes.shape({}).isRequired,
	heading: PropTypes.string,
	headingInfo: PropTypes.string,
	setModalStateData: PropTypes.func.isRequired,
	footnoteConditional: PropTypes.bool,
	isMobile: PropTypes.bool.isRequired
};

IncentiveDetailCategorized.defaultProps = {
	heading: '',
	headingInfo: '',
	footnoteConditional: false
};

export default IncentiveDetailCategorized;



// WEBPACK FOOTER //
// ./src/components/IncentiveDetailCategorized.jsx